// extracted by mini-css-extract-plugin
export var content = "Page-module--content--15vYT";